import Text from '@components/common/text';
import Button from '@components/common/button';
import { useWritingResumePositions } from '@repository/match';
import Item from './item';
import { FontStyle } from '@domain/constant/fontStyle';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Empty = () => {
  return (
    <div className={cx('emptyWrapper')}>
      <Text fontStyle={FontStyle.B2_B}>작성 중인 지원서가 없습니다.</Text>
      <Button href={RouteUrl.POSITION}>포지션 보러 가기</Button>
    </div>
  );
};

const ApplyList = () => {
  const { data, isFetched } = useWritingResumePositions();
  const itemEls = data?.map((item) => <Item key={item.positionSn} data={item} />);

  return (
    <div className={cx('wrapper')}>
      <div className={cx('labelArea')}>
        <div className={cx('column', 'column1')}>지원 내역</div>
        <div className={cx('column', 'column2')}>마감일</div>
      </div>

      {isFetched && !data?.length && <Empty />}
      {itemEls}
    </div>
  );
};
export default ApplyList;
